import { useEffect } from "react";
import axios from "axios";
import liff from "@line/liff";
import LoadingScreen from "../Loading/LoadingScreen";
import { CURRENT_ENV } from "../../Utills/constants";

function BonusTime() {
    useEffect(() => {
        const initLiff = async () => {
            try {
                await liff.init({
                    liffId: CURRENT_ENV.LIFF_ID,
                });

                if (!liff.isLoggedIn()) {
                    liff.login();
                    return;
                }

                let id = new URLSearchParams(window.location.search).get("id");

                if (!id) {
                    const liffState = new URLSearchParams(
                        window.location.search
                    ).get("liff.state");

                    if (liffState) {
                        const decodedState = decodeURIComponent(liffState);
                        const queryString = decodedState.split("?")[1];

                        if (queryString) {
                            id = new URLSearchParams(queryString).get("id");
                        }
                    }
                }

                if (!id) {
                    alert("ไม่พบ id");
                    return;
                }

                const res = await axios.get(
                    `${CURRENT_ENV.API_BASE_URL}/bonustime/${id}`
                );

                const data = res.data;
                await liff.sendMessages([data]);
                liff.closeWindow();
            } catch (error) {
                console.error(error);

                alert(
                    `Error: ${error?.message ||
                    JSON.stringify(error, null, 2)
                    }`
                );
            }
        };

        initLiff();
    }, []);

    return <LoadingScreen />;
}

export default BonusTime;